import { useLazyQueryTrainingModules, useQueryUserTrainings } from "../data"
import { useAuth } from "../services"
import { toId } from "./useDataUtils"
import { useMountEffect } from "./useMountEffect"

const useTraining = () => {
  const {
    principal: { userID },
    hasPermission,
    permissionGroups: { adminTraining },
  } = useAuth()
  const { data, loading } = useQueryUserTrainings({
    variables: {
      user: userID,
    },
  })
  const [loadModules, { data: modulesData }] = useLazyQueryTrainingModules()

  useMountEffect(() => {
    if (hasPermission(adminTraining)) {
      loadModules()
    }
  })

  const getActiveTrainingForKnowledge = (knowledge) => {
    const userTraining = data?.userTrainings.find(
      (item) =>
        item.status.activeKnowledge === toId(knowledge) ||
        (!item.status.completedAt && modulesHaveCompletedKnowledge(item.status.modules, knowledge))
    )
    if (userTraining) {
      const module = userTraining.status.modules.find((item) => toId(item) === toId(userTraining.status.activeModule))
      const moduleKnowledge = module.knowledges.find((item) => toId(knowledge) === toId(item.knowledge))
      if (module) {
        return {
          userTraining,
          module,
          moduleKnowledge,
          knowledgeActive: userTraining.status.activeKnowledge === toId(knowledge),
        }
      }
    }
    return null
  }

  const getActiveModuleIndex = ({ status }) =>
    status.activeModule ? status.modules.findIndex((module) => toId(module) === toId(status.activeModule)) : -1

  const getActiveModule = (userTraining) => {
    const activeModuleIndex = getActiveModuleIndex(userTraining)
    return activeModuleIndex > -1 ? userTraining.status.modules[activeModuleIndex] : null
  }

  const modulesHaveCompletedKnowledge = (modules, knowledge) =>
    modules.some((module) =>
      module.knowledges.some((item) => item.completedAt && toId(item.knowledge) === toId(knowledge))
    )

  return {
    getActiveTrainingForKnowledge,
    getActiveModuleIndex,
    getActiveModule,

    modules: modulesData?.trainingModules || [],
    loading,
  }
}

export { useTraining }
